// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3mr5V","disabled":"FileBtn_disabled__2IXlG","warn":"FileBtn_warn__1OaMf","fade":"FileBtn_fade__1AOO9"};